/**
 * Stringify and set @see value in @see localStorage at @see key.
 *
 * @note Removes the @see key from local storage if the value is `null`.
 */
export function setLocalStorage<T>(key: string, value: T): T {
  if (value == null) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, JSON.stringify(value));
  }
  return value;
}
